/* eslint-disable no-extra-boolean-cast */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { all, call, put, takeEvery, select } from 'redux-saga/effects';
import { actions } from '../../utils/constants';
import history from '../../history';
import routes from '../../utils/routes';

import {
    fetchTemplateQuestions,
    updateTemplateQuestions,
    deleteTemplateQuestion,
} from '../../utils/common-functions';

function* fetchQuestionsSaga({
    payload: { orderBy, orderMode, status, enabled, searchTitle, limit, page },
}) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });
        const params = {};

        Object.assign(params, { order: !!orderBy ? orderBy : 'created_at' });
        Object.assign(params, { order_mode: !!orderMode ? orderMode : 'desc' });

        if (searchTitle) {
            Object.assign(params, { search: searchTitle });
        }

        if (enabled !== undefined) {
            Object.assign(params, {
                enabled,
            });
        }

        if (status) {
            Object.assign(params, { status: status });
        }
        const response = yield call(fetchTemplateQuestions, {
            ...params,
            page: page,
            page_size: limit,
        });
        // eslint-disable-next-line camelcase
        const { total, template_questions } = response.data;
        yield put({
            type: actions.CHANGE_FETCH_QUESTIONS,
            payload: {
                total: total,
                questions: template_questions,
            },
        });
    } catch (err) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível listar as questões',
            },
        });
    }

    yield put({
        type: actions.DECREMENT_LOADING_ONLINE_TESTS,
    });
}

function* enableQuestion({ payload: { questionId, title, enabled, options } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const serializeOptions = options.map(option => {
            return !option.removed
                ? { ...option }
                : {
                      id: option.id,
                      removed: option.removed,
                  };
        });

        const response = yield call(updateTemplateQuestions, {
            questionId,
            data: {
                title: title,
                enabled: enabled,
                options: serializeOptions,
            },
        });

        yield put({
            type: actions.CHANGE_SHOULD_BE_REFRESH_QUESTIONS_DATABASE,
            payload: true,
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }

    yield put({
        type: actions.CHANGE_SHOW_MODAL_DISABLE_QUESTION,
        payload: false,
    });
}

function* removeQuestion({ payload: { questionId } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        yield call(deleteTemplateQuestion, {
            questionId,
        });

        yield put({
            type: actions.CHANGE_SHOULD_BE_REFRESH_QUESTIONS_DATABASE,
            payload: true,
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }

    yield put({
        type: actions.CHANGE_SHOW_MODAL_REMOVE_QUESTION,
        payload: false,
    });
}

export default function* questionsDatabase() {
    yield takeEvery(actions.ASYNC_FETCH_QUESTIONS, fetchQuestionsSaga);
    yield takeEvery(actions.ASYNC_HANDLE_ENABLE_QUESTION, enableQuestion);
    yield takeEvery(actions.ASYNC_REMOVE_QUESTION, removeQuestion);
}



// WEBPACK FOOTER //
// ./src/components/questions-database/questions-database.saga.js